import React from 'react';


import Collection from '../../../common/Collection'

import { errorCatch, POST, deleteInArray } from 'fennec-ui'
import NovieTarifTemplate from '../NovieTarifTemplate';
import IzmenitTarifTemplate from '../IzmenitTarifTemplate';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
dayjs.locale('ru');

export default function TarifTemplate(props) {
    const { auth, object, sourceKey, queryFilterContext } = props;
    return (
        <>
            <Collection
                auth={auth}
                noPrint={true}
                noPagination={false}
                size="small"
                source={"/api/tariftemplate/bymeropriyatie/" + object.ID}
                columns={() => [
                    {
                        title: 'Окончание действия',
                        render: (text, record) => {
                            return (record.dataVremyaOkonchaniya?dayjs(record.dataVremyaOkonchaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm'):"");
                        }
                    },
                    {
                        title: 'Количество проданных до',
                        render: (text, record) => {
                            return (record.kolichestvoDo?record.kolichestvoDo:"");
                        }
                    },
                ]}
                collectionActions={() => [
                    {
                        action: {
                            method: "POST",
                            path: "/api/tariftemplate/new",
                            mutation: "update",
                            onValues: (values) => {
                                return { ...values, meropriyatieID: object.ID }
                            },
                            onClose: ({close}) => {
                                close();
                            }
                        },
                        form: NovieTarifTemplate,
                        triggerOptions: {
                            type: "primary"
                        },
                        title: "Новый шаблон",
                        modal: {
                            title: "Новый шаблон тарифа",
                        }
                    }
                ]}
                modelActions={(item) => [
                    {
                        title: "Изменить",
                        modal: {
                            title: "Изменить услугу на мероприятии",
                        },
                        action: {
                            method: "POST",
                            path: "/api/tariftemplate/update",
                            mutation: "update",
                            onValues: (values) => {
                                return { ...values, ID: item.ID, meropriyatieID: object.ID }
                            },
                            onClose: ({close}) => close()
                        },
                        form: IzmenitTarifTemplate,
                        sourceKey: sourceKey,
                        queryFilterContext: queryFilterContext,
                    },
                    {
                        title: "Удалить",
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/tariftemplate/delete', { ...item },
                                () => setCollection(deleteInArray(collection, item)), errorCatch
                            );
                        },
                    }
                ]}
            />
        </>
    );
}
